import {css} from 'emotion'
import { Colors, Font } from './..'

export const AgendaStyle = (ready) => css({
  paddingBottom: '1rem',
  '.agenda': {
    '&-container': {
      position: 'relative',
      maxWidth: 1440,
      margin: '2rem auto 8rem',
    },
    '&-title': {
      textTransform: 'uppercase',
      fontWeight: 800,
      fontSize: '0.75rem',
    },
    '&-transition': {
      opacity: ready ? 1 : 0,
      transition: 'all 400ms ease',
      transform: `translateY(${ready ? 0: 10}px)`,
    },
    '&-upcomming, &-past-event': {
      margin: '2rem 0',
    },
    '&-past': {
      marginTop: '4rem',
    },
    '&-load': {
      position: 'absolute',
      left: '50%',
      top: 300,
      zIndex: 10,
      opacity: ready ? 0 : 1,
      transition: 'all 400ms ease',
    }
  }
})

export const DatePickerStyle = css({
  textAlign: 'center',
  '.react-datepicker': {
    border: 0,
    fontFamily: Font.base,
    width : '100%',

    '&__tirangle': {
      display: 'none',
    },
    '&__month': {
      '@media (min-width: 1024px)' : {
        marginTop: '2rem',
      },

      '&-container': {
        float: 'none'
      }
    },
    '&__header': {
      background: 'none',
      border: 0
    },
    '&__day--outside-month, &__day-names': {
      '@media (min-width: 1024px)': {
        display: 'none',
      }
    },
    '&__day-name': {
      width: '38px',
      fontSize: '1rem',
    },
    '&__week': {
      '@media (min-width: 1024px)': {
        display: 'inline-block',
        verticalAlign: 'middle',
      }
    },
    '&__day': {
      fontSize: '1rem',
      color: 'black',
      fontFamily: Font.base,
      fontWeight: 800,
      width: '36px',
      textAlign: 'center',
      padding: '10px 0px',
      border: '2px solid transparent',
      margin: 0,
      '&:hover': {
        background: 'none',
        borderRadius: 0,
        borderColor: Colors.lightGrey,
      },
      '&:before': {
        display: 'none',
        textAlign: 'center',
        fontWeight: 200,
        marginBottom: 10,
        fontSize:' 0.865rem',
        '@media all and (min-width: 1024px)': {
          display: 'block',
        },
      },
      '&--fri:before': {
        content: "'F'"
      },
      '&--sat:before': {
        content: "'S'"
      },
      '&--mon:before': {
        content: "'M'"
      },
      '&--sun:before': {
        content: "'S'"
      },
      '&--tue:before': {
        content: "'T'"
      },
      '&--thu:before': {
        content: "'T'"
      },
      '&--wed:before': {
        content: "'W'"
      },
    },
    '&__current-month': {
      fontSize: '2rem',
      textTransform: 'uppercase',
      fontWeight: 800,
      '@media (min-width: 1024px)': {
        fontSize: '2rem',
      }
    },
    '&__day--highlighted': {
      background: 'none',
      color: Colors.red,
      '&:before': {
        color: 'black'
      }
    },
   '&__day--selected, &__day--in-selecting-range, &__day--in-range, &__day--selected:hover, &__day--in-selecting-range:hover, &__day--in-range:hover': {
      background: Colors.red,
      color: 'white',
      borderRadius: 0,

      '&:hover': {
        borderColor: Colors.red
      },
      '&:before': {
        color: 'white'
      }
    },
    '&__day--today': {
      background: 'none',
      borderRadius: 0,
      borderColor: 'black',
      color: 'black',
  
      '&:before': {
        color: 'black',
      },
      '&.react-datepicker__day--highlighted': {
        color: Colors.red
      },
      '&.react-datepicker__day--selected': {
        background: Colors.red,
        color: 'white',
        '&:before': {
          color: 'white',
        }
      }
    },
    '.react-datepicker__day--outside-month': {
      color: Colors.lightGrey
    }
  }
})



// WEBPACK FOOTER //
// ./src/styles/containers/agenda.js